// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#timeplan {
  max-width: 1500px;
  max-height: 90vh;
}

#kalender {
  max-width: 500px;
  height: 200px;
}

.plan-list {
  max-width: 240px;
  min-width: 240px;
}

.plan-list > ul {
  max-height: 90%;
}

.plan-list > ul > li {
  display: flex;
  justify-content: space-between;
}

.search-lib {
  max-height: 400px;
}

.dag-plan {
  height: 80vh;
  margin-left: 3rem;
  border: 2px solid var(--font);
  overflow: auto;
}

.dag-plan td {
  border: none;
  vertical-align: top;
}

.dag-plan li:hover {
  color: var(--white);
  background-color: var(--primary);
}
.dag-plan li.selected {
  color: var(--white);
  background-color: var(--secondary);
}

.search-selected {
  font-size: 18px;
  line-height: 1.4rem;
  flex-wrap: wrap;
}

.search-selected-item {
  border-radius: 6px;
  margin: 4px;
  padding: 5px 10px;
}

.delete {
  margin-left: 2rem;
  cursor: pointer;
}

.col-title {
  color: var(--secondary);
  font-weight: bold;
}

.search input {
  background-color: white;
  border-color: black;
  border-radius: 2px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  font-size: 18px;
  padding: 15px;
  height: 30px;
  width: 300px;
}
.dataResult {
  margin-top: 5px;
  width: 300px;
  height: 200px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow: hidden;
  overflow-y: auto;
}

.dataResult::-webkit-scrollbar {
  display: none;
}

.dataResult .dataItem {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: black;
}

.dataItem p {
  margin-left: 10px;
}

#clearBtn {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./dev/js/timeplan.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,YAAY;EAIZ,mBAAmB;AAHrB;;AAMA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["#timeplan {\n  max-width: 1500px;\n  max-height: 90vh;\n}\n\n#kalender {\n  max-width: 500px;\n  height: 200px;\n}\n\n.plan-list {\n  max-width: 240px;\n  min-width: 240px;\n}\n\n.plan-list > ul {\n  max-height: 90%;\n}\n\n.plan-list > ul > li {\n  display: flex;\n  justify-content: space-between;\n}\n\n.search-lib {\n  max-height: 400px;\n}\n\n.dag-plan {\n  height: 80vh;\n  margin-left: 3rem;\n  border: 2px solid var(--font);\n  overflow: auto;\n}\n\n.dag-plan td {\n  border: none;\n}\n\n.dag-plan td {\n  vertical-align: top;\n}\n\n.dag-plan li:hover {\n  color: var(--white);\n  background-color: var(--primary);\n}\n.dag-plan li.selected {\n  color: var(--white);\n  background-color: var(--secondary);\n}\n\n.search-selected {\n  font-size: 18px;\n  line-height: 1.4rem;\n  flex-wrap: wrap;\n}\n\n.search-selected-item {\n  border-radius: 6px;\n  margin: 4px;\n  padding: 5px 10px;\n}\n\n.delete {\n  margin-left: 2rem;\n  cursor: pointer;\n}\n\n.col-title {\n  color: var(--secondary);\n  font-weight: bold;\n}\n\n.search input {\n  background-color: white;\n  border-color: black;\n  border-radius: 2px;\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  font-size: 18px;\n  padding: 15px;\n  height: 30px;\n  width: 300px;\n}\n.dataResult {\n  margin-top: 5px;\n  width: 300px;\n  height: 200px;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.dataResult::-webkit-scrollbar {\n  display: none;\n}\n\n.dataResult .dataItem {\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  color: black;\n}\n\n.dataItem p {\n  margin-left: 10px;\n}\n\n#clearBtn {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
